import {
  jb_footer_css_default
} from "./chunk.VHDPOBCK.js";
import {
  ae
} from "./chunk.6PQ7B7BC.js";
import {
  jbLinkClickedEventToJbTrackingEvent
} from "./chunk.MFPI4EPN.js";
import {
  reset_css_default
} from "./chunk.PBU2AIHD.js";
import {
  customElement
} from "./chunk.QAGUCU4C.js";
import {
  D,
  ke,
  r
} from "./chunk.NBIYIO67.js";
import {
  n
} from "./chunk.QXWAL3TN.js";
import {
  __decorateClass
} from "./chunk.2QRLEY22.js";

// src/components/jb-footer/jb-footer.ts
var JbFooter = class extends r {
  constructor() {
    super(...arguments);
    this.ARIALABELS_DEFAULT = {
      bluesky: "Follow Julius Baer on BlueSky",
      facebook: "Follow Julius Baer on Facebook",
      instagram: "Follow Julius Baer on Instagram",
      linkedin: "Follow Julius Baer on LinkedIn",
      mail: "Connect by email",
      x: "Follow Julius Baer on X",
      youtube: "Follow Julius Baer on YouTube"
    };
    this.text = "";
  }
  connectedCallback() {
    super.connectedCallback();
    this.socialIcons.map((icon) => {
      if (!icon.ariaLabels?.label) {
        icon.ariaLabels = { label: this.ARIALABELS_DEFAULT[icon.service] || "Social Icon" };
      }
      return icon;
    });
  }
  _renderNavigation(items) {
    return items.map((item) => {
      if (item.link?.href) {
        return ke`<li><jb-anchor .link=${item.link}>${item.text}</jb-anchor></li>`;
      }
      return ke`<li class="copyright">${item.text}</li>`;
    });
  }
  _trackLink(e) {
    const jbTrackingEvent = jbLinkClickedEventToJbTrackingEvent(e, {
      component_name: "footer"
    });
    if (jbTrackingEvent) {
      this.dispatchEvent(jbTrackingEvent);
    }
  }
  _trackSocial(e) {
    e.detail.type = "social";
    const jbTrackingEvent = jbLinkClickedEventToJbTrackingEvent(e, {
      component_name: "footer"
    });
    if (jbTrackingEvent) {
      this.dispatchEvent(jbTrackingEvent);
    }
  }
  render() {
    return ke`
      <footer>
        <div class="wrapper">
          <nav
            class="primary"
            role="navigation"
            aria-label="Footer navigation"
          >
            <ul @jb-link:clicked=${this._trackLink}>
              ${this._renderNavigation(this.primaryNavigation)}
            </ul>
          </nav>
          <div class="social-icons">
            <jb-social-icons
              .items=${this.socialIcons}
              @jb-link:clicked=${this._trackSocial}
            ></jb-social-icons>
          </div>
        </div>
        <nav
          class="secondary"
          role="navigation"
          aria-label="Footer navigation"
        >
          <ul @jb-link:clicked=${this._trackLink}>
            ${this._renderNavigation(this.secondaryNavigation)}
          </ul>
        </nav>
        <jb-richtext
          size="mini"
          @jb-link:clicked=${this._trackLink}
          >${this.text ? ae(this.text) : D}</jb-richtext
        >
      </footer>
    `;
  }
};
JbFooter.styles = [reset_css_default, jb_footer_css_default];
__decorateClass([
  n({ type: Array })
], JbFooter.prototype, "primaryNavigation", 2);
__decorateClass([
  n({ type: Array })
], JbFooter.prototype, "secondaryNavigation", 2);
__decorateClass([
  n({ type: Array })
], JbFooter.prototype, "socialIcons", 2);
__decorateClass([
  n()
], JbFooter.prototype, "text", 2);
JbFooter = __decorateClass([
  customElement("jb-footer")
], JbFooter);

export {
  JbFooter
};
